export default __webpack_public_path__ + "static/media/Carousel2.47ee2c5a.jpg";